import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule, inject, provideAppInitializer } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { LG_APPLICATION_MULTI_EVENT_TRACERS } from "@logex/framework/core";
import {
    LgApplicationModule,
    LgMatTrackingService,
    LG_APP_INFO,
    LG_MATOMO_CONFIGURATION,
    LG_NAVIGATION
} from "@logex/framework/lg-application";
import { SharedUtilAuthorizationModule } from "@mrdm-self-service-frontend/shared/util-authorization";
import {
    SharedConfigService,
    SharedStartupService,
    SharedUtilLogexFrameworkRootModule
} from "@mrdm-self-service-frontend/shared/util-logex-framework-setup";
import { MatomoConfiguration } from "@mrdm-self-service-frontend/shared/util-tracking";
import { AppRoutingModule } from "./app-routing.module";

import { AppComponent } from "./app.component";
import { SharedModule } from "./shared/shared.module";
import { NavigationService } from "./shared/services/app-navigation";

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedUtilLogexFrameworkRootModule,
        SharedUtilAuthorizationModule.forRoot(),
        SharedModule,
        LgApplicationModule
    ],
    providers: [
        provideAppInitializer(() => {
        const initializerFn = ((startup: SharedStartupService) => startup.initialize())(inject(SharedStartupService));
        return initializerFn();
      }),
        {
            provide: LG_APP_INFO,
            useFactory: (configService: SharedConfigService) => {
                const config = configService.getConfiguration();
                return {
                    environment: config?.environment,
                    fullAppName: "",
                    productId: "",
                    toolInstanceName: config?.instance,
                    versionNumber: config?.version,
                    overrideCurrencyPrefix: "",
                    overrideCurrencySuffix: "",
                    doNotDoGaTracking: () => false,
                    isProduction: () => config?.environment === "prod"
                };
            },
            deps: [SharedConfigService]
        },
        {
            provide: LG_NAVIGATION,
            useFactory: (navigationService: NavigationService) => navigationService.navigation$,
            deps: [NavigationService]
        },
        {
            provide: LG_MATOMO_CONFIGURATION,
            useExisting: MatomoConfiguration
        },
        {
            provide: LG_APPLICATION_MULTI_EVENT_TRACERS,
            useExisting: LgMatTrackingService,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {}
